/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Theme_To_LightInputs */

const tr_landing_theme_to_light = /** @type {(inputs: Landing_Theme_To_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açık temaya geç`)
};

const en_landing_theme_to_light = /** @type {(inputs: Landing_Theme_To_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to light theme`)
};

const de_landing_theme_to_light = /** @type {(inputs: Landing_Theme_To_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum hellen Design wechseln`)
};

const ru_landing_theme_to_light = /** @type {(inputs: Landing_Theme_To_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить на светлую тему`)
};

/**
* | output |
* | --- |
* | "Switch to light theme" |
*
* @param {Landing_Theme_To_LightInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_theme_to_light = /** @type {((inputs?: Landing_Theme_To_LightInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Theme_To_LightInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_theme_to_light(inputs)
	if (locale === "de") return de_landing_theme_to_light(inputs)
	if (locale === "ru") return ru_landing_theme_to_light(inputs)
	return tr_landing_theme_to_light(inputs)
});